import {createSelector} from 'reselect';

import {getCurrentChannel} from 'mattermost-redux/selectors/entities/channels';

export const getCurrentChannelName = createSelector(
    getCurrentChannel,
    (channel) => channel?.name,
);
